const MONTHS_SHORT = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];
export const getMonthName = (month) => {
    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];
    return months[month];
};
export const formatTimestamp = (timestamp, options) => {
    const date = new Date(timestamp);
    if (options === null || options === void 0 ? void 0 : options.relativeDay) {
        const dayDiff = Math.floor((new Date(date).setHours(0, 0, 0, 0) - new Date().setHours(0, 0, 0, 0)) / 86400000);
        const hours = date.getHours();
        const h = hours % 12 || 12;
        const time = `${h}:${date.getMinutes().toString().padStart(2, '0')}${hours >= 12 ? 'pm' : 'am'}`;
        const dateLabel = dayDiff === 0
            ? 'Today'
            : dayDiff === 1
                ? 'Tomorrow'
                : `${date.getDate()} ${MONTHS_SHORT[date.getMonth()]} '${date.getFullYear().toString().slice(-2)}`;
        return `${dateLabel}, ${time}`;
    }
    const day = date.getDate();
    const month = getMonthName(date.getMonth());
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${day} ${month} ${year}, ${hours}:${minutes}:${seconds}`;
};
export const formatTimestampShort = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString();
};
export const formatTimestampISO = (timestamp) => {
    return new Date(timestamp).toISOString();
};
